import {clearCards} from '../index-info/list';
import {flyToCoords} from '../methods/fly';
import {decodeTopojsonFeatures} from '../resources/utils';


export const getIncident = (name) => {
  const slug = name.split(' ').join('-');
  let features = window.fireData.incidents.features;
  return features.find(d => d.properties.slug === slug);
}

let paint = {
  'icon-opacity': 1,
  'text-color': '#fff',
  'text-opacity': {
    base: 0,
    stops: [[1, 0], [5, 1]],
  }
}

let layout = {
  "icon-image": "{icon}",
  'icon-size': {
    base: 1,
    stops: [[1, 1], [22, 2.5]],
  },
  'text-field': ['get', 'name'],
  'text-variable-anchor': ['left'],
  'text-font': ['Overpass Mono SemiBold'],
  'text-size': {
    base: 0,
    stops: [[1, 0], [5, 14]],
  },
  'text-padding': {
    base: 15,
    stops: [[1, 10], [8, 20]],
  },
  'icon-allow-overlap': true,
  'text-allow-overlap': false,
  'icon-ignore-placement': true,
  'text-optional': true
};

export const addIncidentsDetailLayer = (fireSlug) => {
  // copy layout obj
  layout['text-field'] = 'Fire origin';
  layout['text-variable-anchor'] = ['left', 'bottom'];
  layout['text-allow-overlap'] = true;
  paint['text-color'] = '#000';
  paint['text-halo-width'] = 3;
  paint['text-halo-color'] = '#fff';
  const fireCenter = getIncident(fireSlug);
  if(fireCenter && fireCenter.properties.x > window.fireMap.getCenter()['lng']){
    layout['text-variable-anchor'] = ['right', 'bottom'];
  }
  addIncidentsLayer(layout, paint, fireSlug);
}

export const addIncidentsIndexLayer = () => {
  addIncidentsLayer(layout, paint);
  window.fireMap.on('mouseenter', 'fire-points', function(e) {
    window.fireMap.getCanvas().style.cursor = 'pointer';
  });

  window.fireMap.on('mouseleave', 'fire-points', function(e) {
    window.fireMap.getCanvas().style.cursor = '';
  });

  window.fireMap.on('click', 'fire-points', function(e) {
    let feature = window.fireMap.queryRenderedFeatures(e.point)[0];
    if(feature.properties.slug){
      // Clear any existing active cards
      clearCards();

      // Active this fire's card
      const card_id = `card-${feature.properties.slug}`;
      const card = document.getElementById(card_id)
      card.classList.add('active');
      let cZoom = window.fireMap.getZoom();
      if(cZoom < 10){
        // Fly away
        flyToCoords(
            parseFloat(feature.properties.x),
            parseFloat(feature.properties.y)
        );

        // Scroll to card
        card.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      }
    }
  });
}

const addIncidentsLayer = (layout, paint, fireSlug=null) => {
  let incidents = window.fireData.incidents;
  if (fireSlug) {
    incidents.features = incidents.features.filter(d => d.properties.slug == fireSlug);
  }
  window.fireData.incidents.features.forEach(f => f.properties.icon = 'fire-ex-bold');
  window.fireMap.addLayer({
    'id': 'fire-points',
    'type': 'symbol',
    'source': {
      "type": "geojson",
      "data": incidents
    },
    "layout": layout,
    'paint': paint
  }, 'state-label');
};
